import React from "react";
import { Link } from "react-router-dom";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      
      {/* Page Header */}
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>
          <Link to="/">Home</Link> <span>/</span> Privacy Policy
        </p>
      </div>

      {/* Content */}
      <div className="privacy-content">

        <section>
          <h2>Introduction</h2>
          <p>
            SPARSH CARGO PRIVATE LIMITED is a young organisation of committed people who
            have had long careers in the Indian Express Industry. It aims to
            render seamless services to customers looking for reliable, prompt,
            and transparent service providers.
          </p>
          <p>
            SPARSH CARGO PRIVATE LIMITED strives to build a service organisation that lives
            up to its commitments transparently and introduces innovative
            solutions by collaborating with stakeholders. The company addresses
            the gap in the marketplace for a dependable logistics partner
            committed to customer care and service excellence.
          </p>
        </section>

        <section>
          <h2>Ownership of Rights</h2>
          <p>
            Any use of this website or its contents, including copying or storing
            it in whole or part, other than for personal, non-commercial use, is
            prohibited without explicit permission from  SPARSH CARGO PRIVATE LIMITED.
          </p>
          <p>
            All information displayed, transmitted, or carried on this website
            is protected by copyright and intellectual property laws. All rights
            are owned by or licensed to SPARSH CARGO PRIVATE LIMITED.
          </p>
          <p>
            You may not modify, publish, transmit, sell, reproduce, distribute,
            or commercially exploit any content available on this website.
          </p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>
            Information, services, names, images, and contents are provided
            “as is” without warranties of any kind, whether express or implied,
            including fitness for a particular purpose.
          </p>
          <p>
            Users should independently verify the suitability of information
            provided. The content on this website is not intended to be legal or
            professional advice.
          </p>
          <p>
            In no event  SPARSH CARGO PRIVATE LIMITED be liable for any direct,
            indirect, incidental, or consequential damages arising from the use
            of this website.
          </p>
          <p>
            All trademarks, logos, and product names remain the property of their
            respective owners.
          </p>
        </section>

        <section>
          <h2>Disabling Cookies</h2>
          <p>
            We provide you with an option to accept or disable cookies on your
            device while visiting the website. Your preference is recorded and
            respected accordingly.
          </p>
        </section>

        <section>
          <h2>More Information</h2>
          <p>
            We hope the information above helps answer your queries. For further
            assistance, you can contact us at{" "}
            <a href="SPARSH.CARGO.PLTD@GMAIL.COM">
              SPARSH.CARGO.PLTD@GMAIL.COM.
            </a>.
          </p>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
